module.exports = __webpack_public_path__ + "static/media/start.77df562e.svg";